module.exports = __webpack_public_path__ + "static/media/CashApp_OurStory.8eef790a.mp4";